module.exports = __webpack_public_path__ + "static/media/angle.ee6bd716.webp";